import axios from 'axios'

const XHR = axios.create({
  baseURL: process.env.TURBINE_BASE
})

const config = (uri, timeout) => ({
  baseURL: uri,
  timeout: timeout
})

axios.defaults.headers.common['x-ss-api-key'] =
  process.env.X_SS_API_KEY
axios.defaults.headers.common['x-ss-token'] =
  window.SSUser && window.SSUser.accessToken

// For Tag Builder
export const SCHEMA_XHR = axios.create(
  config(process.env.TURBINE_BASE, 30000)
)
export const QUERY_XHR = axios.create(
  config(process.env.SCRUNCHIE_BASE, 300000)
)

export default XHR
